import { useMemo } from 'react';
import { generateAllInsights } from '../utils/insights';

/**
 * useBusinessInsights - Generate business intelligence insights
 * Returns actionable insights based on invoice data
 */
export default function useBusinessInsights(invoices = []) {
  return useMemo(() => {
    if (!invoices || invoices.length === 0) {
      return [];
    }
    
    return generateAllInsights(invoices);
  }, [invoices]);
}
